import { useQuery } from '@tanstack/react-query';
import { api } from '../client';
import { queryKeys } from '../query-keys';

export function useVersionSelect() {
  return useQuery({
    queryKey: queryKeys.version.all,
    queryFn: async () => {
      const res = await api.versionApi.apiVersionGet();
      return res.data;
    },
    meta: {
      skipGlobalError: false,
    },
  });
}
